import { FC, ReactElement } from 'react';
import AppModal from '../app-modal/AppModal';
import { Modal } from 'react-bootstrap';
import i18next from 'i18next';
import { Trans } from 'react-i18next';
import PatientForm from './PatientForm';
import { TelerehabilitationProgramDto } from '../../../../shared/dtos/telerehabilitationProgram.dto';

type CreatePatientModalProps = {
  show: boolean;
  telerehabilitationPrograms: TelerehabilitationProgramDto[];
  onClose: () => void;
  onSave: () => void;
}

const CreatePatientModal: FC<CreatePatientModalProps> = ({
  show, 
  telerehabilitationPrograms,
  onClose,
  onSave
}: CreatePatientModalProps): ReactElement => {
  return (
    <AppModal
      size="lg"
      dialogClassName="modal-dialog-centered"
      show={show}
      onHide={onClose}
      backdrop="static" 
      keyboard
    >
      <Modal.Header closeButton>
        <Modal.Title>{i18next.t('patientCreateModal.title')}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-5">
          <Trans
            i18nKey="patientCreateModal.info"
            components={[
              <span className="fw-semibold" />,
            ]}
          />
        </div>
        <PatientForm data={null} telerehabilitationPrograms={telerehabilitationPrograms} onClose={onClose} onSubmit={onSave} />
      </Modal.Body>
    </AppModal>
  );
};


export default CreatePatientModal;
